import React, { useEffect } from "react";
import { Header as MMTHeader } from "pwa-mmt-ui-header";
import AffiliateHeader from "common-aff-header";
import { loginAction } from "./redux/actions/LoginActions";
import { actionSetOrResetLoginModal } from "./pages/travellersDetails/store/actions/TravellerActions";
import { connect } from "react-redux";
import { isHdfcSmartBuyUrl } from "./constants/TrainConstants";
import { HDFC_SMART_BUY_LANDING_URL } from "./constants/Constants";

const ConnectedHeader = props => {
  const MY_BIZ_EXPERIMENTS = {
    mybiztrains: true
  };
  const showHdfcSmartBuy = isHdfcSmartBuyUrl();
  useEffect(() => {
    if (showHdfcSmartBuy) {
      const logoDiv = document.querySelector(".hdfc-header-logo");
      if (logoDiv) {
        const newLogoDiv = logoDiv.cloneNode(true) as HTMLDivElement;
        (newLogoDiv as HTMLElement).style.cursor = "pointer";
        newLogoDiv.addEventListener("click", function(e) {
          e.preventDefault();
          window.location.href =
            HDFC_SMART_BUY_LANDING_URL;
        });
        logoDiv.parentNode?.replaceChild(newLogoDiv, logoDiv);
      }
    }
  }, [showHdfcSmartBuy]);

  return showHdfcSmartBuy ? (
    <AffiliateHeader
      aff={"HDFC_SB"}
      showBgGradient
      showPoweredBy={false}
      showLoginBtn={true}
      showLoginPersuasionSlider={false}
      onLoginFlowComplete={() => props.loginAction(true)}
      onLogout={() => props.loginAction(false)}
    />
  ) : (
    <MMTHeader
      selectedTabName="Trains"
      onLoginFlowComplete={() => props.loginAction(true)}
      onLogout={() => props.loginAction(false)}
      onModalChange={() => props.actionSetOrResetLoginModal(false)}
      activeModal={props.showLoginModal ? "LOGIN" : undefined}
      myBizExperiments={MY_BIZ_EXPERIMENTS}
    />
  );
};

const mapStateToProps = state => {
  const {
    traveller: { showLoginModal }
  } = state;
  return {
    showLoginModal
  };
};

const mapDispatchToProps = dispatch => ({
  loginAction: isLoggedIn => dispatch(loginAction(isLoggedIn)),
  actionSetOrResetLoginModal: showLoginModal =>
    dispatch(actionSetOrResetLoginModal(showLoginModal))
});

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedHeader);
